import gallery from "../components/gallerySplide";
import splide, { customSplide } from "../utils/splide";
require("fslightbox");

const page = document.getElementById("page");
if (page) {
    const pageSplide = splide(page, {
        perPage: 1,
        breakpoints: {
            1200: {
                perPage: 1,
                arrows: false,
                pagination: true,
            },
            600: {
                perPage: 1,
                arrows: false,
                pagination: true,
            },
        },
    });
    pageSplide.mount();
}
